import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Layout from "../components/layout/layout"
import contentStyles from "../components/content/content.module.scss"


const HtbPage = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: {frontmatter: {type: {eq: "htb"}}}, sort: {fields: frontmatter___date, order: DESC}) {
        edges {
          node {
            frontmatter {
              title
              date
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <div className={contentStyles.content}>
        <h1>Hackthebox Writeups</h1>
        <p>Writeups for some boxes I have completed.</p>
      
        <ol>
          {data.allMarkdownRemark.edges.map(edge => {
            const link = `/htb/${edge.node.fields.slug}`

            return (
              <li className={contentStyles.navList}>
                <Link className={contentStyles.navItem} to={link}>
                  {edge.node.frontmatter.title}
                </Link>
                <p>{edge.node.frontmatter.date}</p>
              </li>
            )
          })}
        </ol>
      </div>
    </Layout>
  )
}

export default HtbPage
